import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import { ViewVariant } from "@/common/ts/layout";
import { ContractDto } from "@/core/api/generated/v1";

import ChargePaginatedList from "../../../Charge/ListView/ChargePaginatedList";

interface Props {
  contract: ContractDto;
}

export default function ChargesTabContent({ contract }: Props) {
  return (
    <PageTabContent>
      <ChargePaginatedList
        defaultValues={{
          contractId: contract.id!,
        }}
        displayProps={{
          viewVariant: ViewVariant.Tab,
          header: false,
          counters: false,
        }}
      />
    </PageTabContent>
  );
}
